<template>
  <div>
    <app-overlay-loader v-if="preloader" />
    <form
      ref="form"
      data-url="/evaluator/evaluationPlan/report/annexes"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row"> 
        <div class="col-12" v-if="accApp && accApp.acc_parent_id">
          <legend>
            <p class="text-primary">Documentos acreditación inicial</p>
          </legend>
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th
                      scope="col"
                      class="align-middle text-center"
                      style="width: 30%"
                    >
                      OEC
                    </th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="accApp">
                    <td class="align-middle">Acreditación inicial</td>
                    <td class="align-middle text-center">
                      {{
                        accApp.organization
                          ? `${accApp.organization.business_name}`
                          : ""
                      }}
                    </td>
                    
                    <td class="align-middle text-center">
                      <a
                        class="btn btn-success"
                        :href="`/evaluator/evaluationPlan/report/viewAccreditationDocument/${accApp.acc_parent_id}`"
                        target="_blank"
                        ><app-icon name="file" /> {{ $t("view") }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        <div class="col-12">
          <legend>
            <p class="text-primary">Documentos anteriores</p>
          </legend>
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th
                      scope="col"
                      class="align-middle text-center"
                      style="width: 25%"
                    >
                      USUARIO
                    </th>
                    <th scope="col" class="text-center" style="width: 15%">
                      FECHA DE CREACIÓN
                    </th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="accApp && accApp.request_signed">
                    <td class="align-middle">Solicitud de Acreditación</td>
                    <td class="align-middle text-center">
                      {{
                        accApp.request_signed.user
                          ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ accApp.request_signed.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(accApp, 'request_signed')"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                  <tr v-if="accApp && accApp.request_signed">
                    <td class="align-middle">
                      Anexos de la Solicitud de Acreditación
                    </td>
                    <td class="align-middle text-center">
                      {{
                        accApp.user
                          ? `${accApp.user.first_name} ${accApp.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ accApp.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <a
                        class="btn btn-success"
                        :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                        target="_blank"
                        ><app-icon name="file" /> {{ $t("view") }}</a
                      >
                    </td>
                  </tr>
                  <tr v-if="evalTest && evalTest.file_evaluation">
                    <td class="align-middle">Propuesta del Equipo Evaluador</td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.file_evaluation.user
                          ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ evalTest.file_evaluation_date | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(evalTest, 'file_evaluation')"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                  <tr v-if="evalTest && evalTest.sampling_plan_file">
                    <td class="align-middle">Plan de Muestreo</td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.sampling_plan_file.user
                          ? `${evalTest.sampling_plan_file.user.first_name} ${evalTest.sampling_plan_file.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ evalTest.sampling_plan_file.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest.risk_matrix">
                    <td class="align-middle">Matriz de Riesgo</td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.risk_matrix.user
                          ? `${evalTest.risk_matrix.user.first_name} ${evalTest.risk_matrix.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ evalTest.risk_matrix.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(evalTest, 'risk_matrix')"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest.standard_evaluate">
                    <td class="align-middle">
                      Borrador del plan de evaluación
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.standard_evaluate.user
                          ? `${evalTest.standard_evaluate.user.first_name} ${evalTest.standard_evaluate.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ evalTest.standard_evaluate.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(evalTest, 'standard_evaluate')"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest.evaluation_team_designation">
                    <td class="align-middle">Designaciones Equipo Evaluador</td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.evaluation_team_designation.user
                          ? `${evalTest.evaluation_team_designation.user.first_name} ${evalTest.evaluation_team_designation.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.evaluation_team_designation.created_at
                          | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'evaluation_team_designation')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest && evalTest.report_documentary_evaluation">
                    <td class="align-middle">
                      (Evaluación Documental) Informe de Evaluación Documental
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.report_documentary_evaluation.user
                          ? `${evalTest.report_documentary_evaluation.user.first_name} ${evalTest.report_documentary_evaluation.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.report_documentary_evaluation.created_at
                          | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'report_documentary_evaluation')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest && evalTest.scope401">
                    <td class="align-middle">
                      (Evaluación Documental) Alcance de Acreditación
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.scope401.user
                          ? `${evalTest.scope401.user.first_name} ${evalTest.scope401.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ evalTest.scope401.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab(evalTest, 'scope401')"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest && evalTest.first_instance_finding403">
                    <td class="align-middle">
                      (Evaluación Documental) Primera entrega - Informe para el
                      cierre de hallazgos y decisión
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.first_instance_finding403.user
                          ? `${evalTest.first_instance_finding403.user.first_name} ${evalTest.first_instance_finding403.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.first_instance_finding403.created_at
                          | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'first_instance_finding403')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest && evalTest.request_additional_evidence">
                    <td class="align-middle">
                      (Evaluación Documental) Solicitud de Evidencias
                      Adicionales
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.request_additional_evidence.user
                          ? `${evalTest.request_additional_evidence.user.first_name} ${evalTest.request_additional_evidence.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.request_additional_evidence.created_at
                          | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'request_additional_evidence')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                  <tr v-if="evalTest && evalTest.closing_finding_report">
                    <td class="align-middle">
                      (Evaluación Documental) Informe para el cierre de
                      hallazgos y decisión (Evaluador)
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.closing_finding_report.user
                          ? `${evalTest.closing_finding_report.user.first_name} ${evalTest.closing_finding_report.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.closing_finding_report.created_at | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'closing_finding_report')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <!-- <tr v-if="evalTest && evalTest.request_additional_evidence_2">
                  <td class="align-middle">
                    (Evaluación Documental) Segunda Solicitud de Evidencias
                    Adicionales
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.request_additional_evidence_2.user
                        ? `${evalTest.request_additional_evidence_2.user.first_name} ${evalTest.request_additional_evidence_2.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.request_additional_evidence_2.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'request_additional_evidence_2')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr> -->

                  <tr v-if="evalTest && evalTest.second_instance_finding403">
                    <td class="align-middle">
                      (Evaluación Documental) Segunda entrega - Informe para el
                      cierre de hallazgos y decisión
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.second_instance_finding403.user
                          ? `${evalTest.second_instance_finding403.user.first_name} ${evalTest.second_instance_finding403.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.second_instance_finding403.created_at
                          | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'second_instance_finding403')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                  <tr v-if="evalTest && evalTest.closing_finding_report_second">
                    <td class="align-middle">
                      (Evaluación Documental) 2do Informe para el cierre de
                      hallazgos y decisión (Evaluador)
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.closing_finding_report_second.user
                          ? `${evalTest.closing_finding_report_second.user.first_name} ${evalTest.closing_finding_report_second.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.closing_finding_report_second.created_at
                          | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'closing_finding_report_second')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <tr v-if="evalTest && evalTest.evaluation_plan_report">
                    <td class="align-middle">Plan de Evaluación</td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.evaluation_plan_report.user
                          ? `${evalTest.evaluation_plan_report.user.first_name} ${evalTest.evaluation_plan_report.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.evaluation_plan_report.created_at | dateFormat
                      }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(evalTest, 'evaluation_plan_report')
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>

                  <!-- <tr v-if="evalTest && evalTest.accepted_evaluation_plan">
                  <td class="align-middle">
                    Plan de Evaluación (Aprobado por el OEC)
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.accepted_evaluation_plan.user
                        ? `${evalTest.accepted_evaluation_plan.user.first_name} ${evalTest.accepted_evaluation_plan.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.accepted_evaluation_plan.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'accepted_evaluation_plan')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-6">
        <div class="form-group">
          <label>Evaluacion Documental</label>
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab('report_documentary_evaluation')"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Plan de Evaluacion</label>
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab('evaluation_plan_report')"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Designación de equipo evaluador</label>
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab('file_evaluation')"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Plan de Evaluación (Aprobado)</label>
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab('accepted_evaluation_plan')"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
        </div>
      </div> -->

        <div class="col-12" v-if="evalTest.management_system_file && evalTest.management_system_file.length > 0 && evalTest.type == 'E'">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Documentación del OEC previo a la 
              <span class="title-legend" v-if="evalTest.type == 'E'">evaluación</span>
              <span class="title-legend" v-if="evalTest.type == 'T'">testificación</span>
            </h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th
                  scope="col"
                  class="align-middle text-center"
                  style="width: 25%"
                >
                  USUARIO
                </th>
                <th scope="col" class="text-center" style="width: 15%">
                  FECHA DE CREACIÓN
                </th>
                <th scope="col" class="text-center" style="width: 10%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in evalTest.management_system_file" :key="i">
                <td class="align-middle">
                  {{ v.filename }}
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.annexed">
                    {{ v.annexed.user.first_name }}
                    {{ v.annexed.user.last_name }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span>{{ v.created_at | dateFormat }}</span>
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(v, 'annexed')"
                    v-if="v.annexed"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12">
          <app-note
            class="mb-primary"
            :show-title="false"
            :notes="['Todos los campos con un (*) son obligatorios.']"
          />
        </div>

        <div class="col-12">
          <legend>
            <p class="text-primary">Anexos</p>
          </legend>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Registro de asistencia participacion</label>
            <app-input type="dropzone" v-model="files_1" />

            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 8MB</strong>
              </small>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col" class="text-center" style="width: 20%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in inputs.attendance_record" :key="key">
                <td class="align-middle">
                  <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(inputs.attendance_record, key)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Reunion de preparacion de evaluación</label>
            <app-input type="dropzone" v-model="files_2" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 8MB</strong>
              </small>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col" class="text-center" style="width: 20%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in inputs.preparation_meeting" :key="key">
                <td class="align-middle">
                  <small class="text-primary">
                    {{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}</small
                  >
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(inputs.preparation_meeting, key)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Cuestionario de Evaluación Técnicos</label>
            <app-input type="dropzone" v-model="files_3" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 15MB</strong>
              </small>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col" class="text-center" style="width: 20%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, key) in inputs.evaluation_questionnaire"
                :key="key"
              >
                <td class="align-middle">
                  <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(inputs.evaluation_questionnaire, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Informe Participación Expertos Técnicos</label>
            <app-input type="dropzone" v-model="files_4" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 8MB</strong>
              </small>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col" class="text-center" style="width: 20%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, key) in inputs.expert_participation_record"
                :key="key"
              >
                <td class="align-middle">
                  <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(inputs.expert_participation_record, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div class="col-md-6">
        <div class="form-group">
          <label>Reuniones de Evaluación, Registro de Asistencia</label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            v-if="!inputs.attendance_record"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'attendance_record')"
              v-if="inputs.attendance_record"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('attendance_record')"
              v-if="inputs.attendance_record"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Cuestionario de Evaluación Técnicos</label>
          <app-input
            type="file"
            :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
            v-model="inputs.file_2"
            v-if="!inputs.evaluation_questionnaire"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'evaluation_questionnaire')"
              v-if="inputs.evaluation_questionnaire"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('evaluation_questionnaire')"
              v-if="inputs.evaluation_questionnaire"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->

        <div class="col-md-6">
          <div class="form-group">
            <label
              >Informe de evaluación In-Situ Remota<b
                class="text-danger ml-2"
                style="font-size: 18px !important"
                >*</b
              ></label
            >
            <app-input
              type="file"
              :label="
                inputs.file_3 ? inputs.file_3.name : $t('upload_your_file')
              "
              v-model="inputs.file_3"
              v-if="!inputs.remote_in_situ_assessment_report"
            />
            <div>
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="
                  openTab(inputs, 'remote_in_situ_assessment_report')
                "
                v-if="inputs.remote_in_situ_assessment_report"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="
                  openDeleteModal('remote_in_situ_assessment_report')
                "
                v-if="inputs.remote_in_situ_assessment_report"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label
              >Matriz de Análisis de riesgos y programa</label>
            <app-input
              type="file"
              :label="
                inputs.file_7 ? inputs.file_7.name : $t('upload_your_file')
              "
              v-model="inputs.file_7"
              v-if="!inputs.risk_matrix505"
            />
            <div>
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs, 'risk_matrix505')"
                v-if="inputs.risk_matrix505"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal('risk_matrix505')"
                v-if="inputs.risk_matrix505"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-6">
        <div class="form-group">
          <label>Informe Participación Expertos Técnicos</label>
          <app-input
            type="file"
            :label="inputs.file_6 ? inputs.file_6.name : $t('upload_your_file')"
            v-model="inputs.file_6"
            v-if="!inputs.expert_participation_record"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'expert_participation_record')"
              v-if="inputs.expert_participation_record"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('expert_participation_record')"
              v-if="inputs.expert_participation_record"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->

        <!-- <div class="col-md-6">
        <div class="form-group">
          <label
            >Alcance de Acreditación<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file_5 ? inputs.file_5.name : $t('upload_your_file')"
            v-model="inputs.file_5"
            v-if="!inputs.scope_505"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'scope_505')"
              v-if="inputs.scope_505"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('scope_505')"
              v-if="inputs.scope_505"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->
      </div>

      <div class="row">
        <!--
      <div class="col-12">
        <div class="form-group">
          <label>Otro</label>
          <app-input
            type="textarea"
            v-model="inputs.other_findings"
            placeholder="Ingrese la evidencia"
          />
          <app-input
            type="file"
            :label="inputs.file_4 ? inputs.file_4.name : $t('upload_your_file')"
            v-model="inputs.file_4"
            v-if="!inputs.other_findings_file"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'other_findings_file')"
              v-if="inputs.other_findings_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('other_findings_file')"
              v-if="inputs.other_findings_file"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->
        <div class="col-sm-12">
          <br />
          <div class="float-left mb-3 mb-3">
            <div class="form-group text-left">
              <label>¿Existen no conformidades?</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.non_conformities_505"
                :list="confirm"
              />
            </div>
          </div>
        </div>

        <div class="col-md-8 mb-3" v-if="false">
          <div class="form-group">
            <label>
              Informe para el cierre de hallazgos y decisión
              <b
                class="text-danger ml-2"
                style="font-size: 18px !important"
              >*</b>
            </label>
            <app-input
                type="file"
                :label="
                  inputs.file_8 ? inputs.file_8.name : $t('upload_your_file')
                "
                v-model="inputs.file_8"
                v-if="!inputs.findings_closing_report_603_first"
              />
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'findings_closing_report_603_first')"
                  v-if="inputs.findings_closing_report_603_first"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal('findings_closing_report_603_first')"
                  v-if="inputs.findings_closing_report_603_first"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
          </div>
        </div>

        <div class="col-sm-12" v-if="isLaboratoriAccApp">
          <br />
          <div class="float-left mb-3 mb-3">
            <div class="form-group text-left">
              <label>¿Quedan testificaciones pendientes?</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.pending_testifications_505"
                :list="pendindgsTestifications"
              />
            </div>
          </div>
        </div>
      </div>

    <div>
      <div class="form-group">
        <label class="text-primary"
          ><b
            >Si desea agregar archivos extras, ingresar en la siguiente
            sección:</b
          ></label
        >
      </div>
      <div class="row mb-2" v-for="(vj, j) in other_file_505" :key="j">
        <div class="col-12 col-md-5" v-if="!vj.annexed">
          <app-input
            :id="`file_${j}`"
            type="file"
            :label="vj.file ? vj.file.name : $t('upload_your_file')"
            v-model="vj.file"
            @change="onChange($event, j)"
          />
          <small v-if="!vj.annexed" class="text-center text-danger"
            >Tamaño máximo del archivo 20 Mb</small
          >
        </div>

        <div class="col-12 col-md-6" v-if="vj.annexed">
          <button
            type="submit"
            class="btn btn-success"
            @click.prevent="openFile(vj.annexed)"
          >
            <app-icon name="file" /> Ver
          </button>

          <button
            type="submit"
            class="btn btn-danger"
            @click.prevent="openDeleteModalFile(j, vj)"
          >
            <app-icon name="trash-2" /> Eliminar
          </button>
        </div>

        <div class="col-12 col-md-5" v-if="vj.annexed">
          <app-input
            :id="`filename_${j}`"
            type="text"
            v-model="vj.filename"
            placeholder="Descripcion del archivo"
            @keyup="onKeyUp(j)"
          />
          <small v-if="!vj.filename" class="text-center text-danger"
            >Es necesario agregar una descripción</small
          >
        </div>
        <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
          <button
            type="submit"
            class="btn btn-warning"
            @click="removeRowFile(j)"
            v-if="!vj.annexed"
          >
            Quitar
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <button type="submit" class="btn btn-primary" @click.prevent="addFile()">
            <app-icon name="plus" /> Agregar archivo
          </button>
        </div>
      </div>
    </div>

    <hr />
    <div class="alert alert-warning col-12" role="alert">
        Después de <b>Guardar</b> deberá <b>Procesar</b> el registro
      </div>
    <div class="row">
      <div class="col-12 mt-4">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
        <button v-if="showOnlyStatus505"
          type="button"
          class="btn btn-success btn-with-shadow ml-3"
          @click="openDeleteModalProccess"
        >
          Procesar
        </button>
      </div>
    </div>
  </form>

    <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este archivo?"
      />

    <app-confirmation-modal
      v-if="deleteModalFilesExtras"
      modal-id="delete"
      @confirmed="acept"
      @cancelled="cancel"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmedProccess"
      @cancelled="cancelledProccess"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost, axiosPatch, axiosDelete } from "@/app/helpers/AxiosHelper";
import { axiosGet } from "../../../../../../../../../resources/js/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
      deleteModal: false,
      deleteModalFilesExtras: false,
      selected: "",
      docs: "",
      other_file_505: [],
      isLaboratoriAccApp: false,
      showOnlyStatus505: false,
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      pendindgsTestifications: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      non_conformities: null,
      files_1: [],
      files_2: [],
      files_3: [],
      files_4: [],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.data();
    this.loadForm();
  },

  methods: {
    addFile() {
      if (this.other_file_505.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.other_file_505.push({
        record_id: this.$store.state.evaluatorReview.evalTestId,
        filename: null,
        file: null,
      });
    },
    openFileTab(obj, fileName) {
      // console.log(file);

      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openFile(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModalFile(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },
    cancel() {
      this.deleteModal = false;
    },

    removeRowFile(j) {
      this.other_file_505 = this.other_file_505.filter(
        (value, index) => index != j
      );
    },
    onChange(e, j) {
      const tmp = this.other_file_505[j];
      if (!tmp.file) return;

      if (tmp.file.size > 20000000) {
        this.$set(this.other_file_505[j], "file", null);
        this.$set(this.other_file_505[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 20MB");
        return;
      }
      if (!tmp.filename) this.$set(this.other_file_505[j], "filename", "");
      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.other_file_505[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },

    removeRowFile(j) {
      this.other_file_505 = this.other_file_505.filter(
        (value, index) => index != j
      );
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/evaluator/documentaryEvaluation/addExtraFileAttach`;
      const tmpo = this.other_file_505[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.other_file_505[j])) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.other_file_505];
            tmp[j] = data;
            this.other_file_505 = tmp;
          }
        })
        .catch(({ error }) => {});
    },
    acept(fileName) {
      const url = `/evaluator/destroyFileAttach505?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModalFilesExtras = false;
          this.deleteModalFilesExtras = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "other_file_505") {
            const tmp = this.other_file_505.filter(
              (value, index) => index != this.tmp.j
            );
            this.other_file_505 = tmp;
          }
        })
        .catch(({ error }) => {});
    },
    cancell() {
      this.deleteModalFilesExtras = false;
    },

    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      if (
        (this.files_1.length > 0 && this.validateFileSize(this.files_1) > 0) ||
        (this.files_2.length > 0 && this.validateFileSize(this.files_2) > 0) ||
        // (this.files_3.length > 0 && this.validateFileSize(this.files_3) > 0) ||
        (this.files_4.length > 0 && this.validateFileSize(this.files_4) > 0)
      ) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 20MB");
        return;
      }

      if (
        this.files_3.length > 0 &&
        this.validateFileSizeCuestionaries(this.files_3) > 0
      ) {
        this.$toastr.e(
          "El tamaño maximo permitido para Cuestionarios de Evaluación de cada archivo es de 20MB"
        );
        return;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      this.files_1.forEach((file) => {
        formData.append("files_1[]", file);
      });

      this.files_2.forEach((file) => {
        formData.append("files_2[]", file);
      });

      this.files_3.forEach((file) => {
        formData.append("files_3[]", file);
      });

      this.files_4.forEach((file) => {
        formData.append("files_4[]", file);
      });

      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
      this.files_1 = [];
      this.files_2 = [];
      this.files_3 = [];
      this.files_4 = [];
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    openDeleteModalFile(j, vj) {
      this.deleteModalFilesExtras = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        if (
          this.$store.state.evaluatorReview.evalTest.accreditation_applications
        ) {
          // Testificaciones pendientes ? solo para Laboratorio.
          if (
            this.$store.state.evaluatorReview.evalTest
              .accreditation_applications.accreditation_area.name ==
            "LABORATORIOS"
          ) {
            this.isLaboratoriAccApp = true;
          }
        }
        this.other_file_505 =
          this.$store.state.evaluatorReview.evalTest.other_file_505;
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTestId,
          attendance_record:
            this.$store.state.evaluatorReview.evalTest.attendance_record,
          preparation_meeting:
            this.$store.state.evaluatorReview.evalTest.preparation_meeting,
          evaluation_questionnaire:
            this.$store.state.evaluatorReview.evalTest.evaluation_questionnaire,
          other_findings:
            this.$store.state.evaluatorReview.evalTest.other_findings,
          other_findings_file:
            this.$store.state.evaluatorReview.evalTest.other_findings_file,
          report_documentary_evaluation:
            this.$store.state.evaluatorReview.evalTest
              .report_documentary_evaluation,
          evaluation_plan_report:
            this.$store.state.evaluatorReview.evalTest.evaluation_plan_report,
          remote_in_situ_assessment_report:
            this.$store.state.evaluatorReview.evalTest
              .remote_in_situ_assessment_report,
          risk_matrix505:
            this.$store.state.evaluatorReview.evalTest.risk_matrix505,
          file_evaluation:
            this.$store.state.evaluatorReview.evalTest.file_evaluation,
          expert_participation_record:
            this.$store.state.evaluatorReview.evalTest
              .expert_participation_record,
          accepted_evaluation_plan:
            this.$store.state.evaluatorReview.evalTest.accepted_evaluation_plan,
          scope_505: this.$store.state.evaluatorReview.evalTest.scope_505,
          non_conformities_505:
            this.$store.state.evaluatorReview.evalTest.non_conformities_505,
          pending_testifications_505:
            this.$store.state.evaluatorReview.evalTest
              .pending_testifications_505,
          other_file_505:
            this.$store.state.evaluatorReview.evalTest.other_file_505,
          findings_closing_report_603_first:
            this.$store.state.evaluatorReview.evalTest.findings_closing_report_603_first,
        };

        this.non_conformities = this.$store.state.evaluatorReview.evalTest.non_conformities;
        // Validar visualizacion vista en estado 505 - 603 - 604
        this.axiosGet(
        `/evaluator/evaluationPlan/report/info/${this.$store.state.evaluatorReview.evalTest.id}`
      )
        .then((response) => {
            if(response.data.code == 505){
              this.showOnlyStatus505 = true;
            }else{  this.showOnlyStatus505 = false; }
        })
        .catch((error) => {
        });
      }
    },

    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 20000000) {
          return file;
        }
      }).length;
    },

    validateFileSizeCuestionaries(files) {
      return files.filter((file) => {
        if (file.size > 20000000) {
          return file;
        }
      }).length;
    },
    openDeleteModalProccess() {
      this.deleteConfirmationModalActive = true;
    },
    confirmedProccess() {
      let url = `/evaluator/evaluationPlan/report/process?evalTestId=${this.$store.state.evaluatorReview.evalTestId}`;
      this.deleteLoader = true;
      this.preloader = true;
      axiosPatch(url, { non_conformities: this.non_conformities })
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelledProccess();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {}
        ).finally(() => {
          this.preloader = false;
        });
    },
    cancelledProccess() {
      this.deleteConfirmationModalActive = false;
    },
    returnPage() {
      window.location.href = `/evaluator/evaluationPlan?tab=Elaboración%20de%20Informe%20de%20Evaluación%20In%20Situ%20/%20Remota`;
    },
  },
};
</script>
